import { render, staticRenderFns } from "./PageAiaoleGov.vue?vue&type=template&id=07287af4&scoped=true&"
import script from "./PageAiaoleGov.vue?vue&type=script&lang=js&"
export * from "./PageAiaoleGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07287af4",
  null
  
)

export default component.exports